import { useCallback, useEffect, useState } from 'react';

/**
 * 残りの秒数（0 なら待っていない）。start(秒) で数え始め、1秒ごとに減らす。
 * 送り直しの間隔（Retry-After）と、試行の制限で待つ秒数に使う。
 */
export function useCountdown(initialSeconds = 0): [number, (seconds: number) => void] {
  const [until, setUntil] = useState(() =>
    initialSeconds > 0 ? Date.now() + initialSeconds * 1000 : 0
  );
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    if (until <= now) return undefined;
    const timer = window.setTimeout(() => setNow(Date.now()), 1000);
    return () => window.clearTimeout(timer);
  }, [until, now]);

  const start = useCallback((seconds: number) => {
    const current = Date.now();
    setNow(current);
    setUntil(seconds > 0 ? current + seconds * 1000 : 0);
  }, []);

  const left = until > now ? Math.ceil((until - now) / 1000) : 0;
  return [left, start];
}
